import React from 'react';
import { useStyles } from '../../contexts/StyleContext';

const Select = ({
  label,
  error,
  options = [],
  placeholder = 'Select an option',
  className = '',
  ...props
}) => {
  const styles = useStyles();
  const { form } = styles;

  const selectClasses = `
    w-full 
    px-4 
    py-3 
    rounded-lg 
    border-2 
    bg-white 
    transition-all 
    duration-200
    focus:ring-2
    appearance-none
    ${error ? 'border-red-500' : ''}
    ${className}
  `.trim();

  const selectStyle = {
    borderColor: error ? '#EF4444' : form.input.border,
    backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
    backgroundPosition: 'right 0.75rem center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5em 1.5em',
    paddingRight: '2.5rem',
    ':focus': {
      borderColor: form.input.focus.border,
      '--tw-ring-color': form.input.focus.ring
    }
  };

  const labelClasses = `
    block 
    text-sm 
    font-semibold 
    uppercase 
    tracking-wide 
    mb-2
  `.trim();

  const labelStyle = {
    color: form.label.color
  };

  const errorClasses = `
    mt-1 
    text-sm 
    text-red-500
  `.trim();

  return (
    <div className="mb-4">
      {label && (
        <label 
          className={labelClasses}
          style={labelStyle}
        >
          {label}
        </label>
      )}
      <select
        className={selectClasses}
        style={selectStyle}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option 
            key={option.value} 
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className={errorClasses}>{error}</p>
      )}
    </div>
  );
};

export default Select;
